import _ from 'lodash';

type GetOveralScoreResponse = {
  score: number;
  passingScore: number;
  passed: boolean;
  completed: boolean;
  scoreByQuiz: GetScoresResponse[];
};

export const getOverallScore = (
  course: any,
  tracking: any
): GetOveralScoreResponse => {
  let scoreSum = 0;
  let passingScoreSum = 0;
  let completedAll = true;

  const scores = getScores(course, tracking);

  _.forEach(scores, (s) => {
    scoreSum += +s.score;
    passingScoreSum += +s.passingScore;
    completedAll = s.completed && completedAll;
  });

  const score = Math.round(scoreSum / scores.length);
  const passingScore = Math.round(passingScoreSum / scores.length);

  return {
    score,
    passingScore,
    passed: score >= passingScore,
    completed: completedAll,
    scoreByQuiz: scores,
  };
};

type GetScoresResponse = {
  resourceId: string;
  title: string;
  score: number;
  passingScore: number;
  completed: boolean;
};

const getScores = (course: any, tracking: any): GetScoresResponse[] => {
  // 1. filter all quizzes from this course
  const quizzes = _.filter(course?.pages, (p) => p?.resourceType === 'quiz');

  // 2. is there any quiz with computeOverallScore setted?
  const hasAnyQuizWithOverallConfig = !!_.find(
    quizzes,
    (q) => q?.quiz?.config?.computeOverallScore === true
  );

  // 3. filter quizzes with computeOverallScore OR the last quiz
  const quizzesToConsider = hasAnyQuizWithOverallConfig
    ? _.filter(quizzes, (q) => q?.quiz?.config?.computeOverallScore === true)
    : [quizzes[quizzes.length - 1]];

  // 4. return the data
  const _scores = _.map(quizzesToConsider, (quiz) => {
    const quizTracking = _.get(tracking, quiz?.resourceId);

    return {
      resourceId: quiz?.resourceId,
      title: quiz?.title,
      score: quizTracking?.result?.score || 0,
      passingScore: quiz?.quiz?.config?.passingScore || 0,
      completed: quizTracking?.completed,
    };
  });

  return _scores;
};
